import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NoContentBox } from 'components/basic'
import { notify } from 'helpers'
import http from 'API/http'
import FileSaver from 'file-saver'

class SubscriptionExport extends Component {
  async componentDidMount () {
    var err, res
    [err, res] = await http.get('export/subscriptions/csv/')
    if (err) notify.alert('', 'Export failed, try again', 'error')
    if (!err) {
      var blob = new window.Blob([res.data], { type: 'text/csv' })
      FileSaver.saveAs(blob, 'SubscriptionExport.csv')
    }
    window.location.hash = '/dashboard'
  }
  render () {
    return (
      <div className='content-wrapper flexbox-absolute-center'>
        <NoContentBox icon='circle-o-notch fa-spin' text='Downloading...' />
      </div>
    )
  }
}
//eslint-disable-next-line
SubscriptionExport = connect(state => state.siteReducer)(SubscriptionExport)
export default SubscriptionExport



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/core/export/subscriptions.js